import { Button } from "reactstrap"
import { Row, Col } from "reactstrap"
import { handleExportDataForUserRole } from "./Constant/handleExportDataForUserRole"
export const UserRoleCustomButtons = ({ navigate, Roles, UserRolesSummary, toggleSettingsModal, viewPermission,rolesPermission }) => {
    const userRolesSummaryCards = [
        {
            label: "Number of Roles",
            value: UserRolesSummary?.numberOfRoles,
            icon: "ri-shield-line",
            color: "#0053CF",
        },
        {
            label: "Default Roles",
            value: UserRolesSummary?.defaultRoles,
            icon: "ri-shield-line",
            color: "#FF9900",
        },
        {
            label: "Custom Roles",
            value: UserRolesSummary?.customRoles,
            icon: "ri-shield-line",
            color: "#276D20",
        },
    ];

    return (
        <div className="w-100">
            <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between w-100">
                <h5 className="rv-page-title p-1">Users Roles List</h5>
                <div className="d-flex align-items-center">
                    <div className="d-flex ">
                        {rolesPermission && rolesPermission?.has("export") &&
                            <Button
                                color="secondary"
                                className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 me-2 w-md-auto text-nowrap"
                                onClick={() => { handleExportDataForUserRole(Roles) }}
                            >
                                <i className="ri-download-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                <span className="px-2 ps-3 ms-2 me-1">Export</span>
                            </Button>}
                        {rolesPermission && rolesPermission?.has("create") &&
                            <Button
                                color="secondary"
                                className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 me-2 w-100 w-md-auto text-nowrap"
                                onClick={() => {
                                    navigate("/add-userrole")
                                    //Navigate to Add User Role 
                                }}
                            >
                                <i className="ri-add-fill label-icon align-middle fs-16 me-1"></i>
                                <span className="ps-2 ms-2 me-1">Add Role</span>
                            </Button>}
                    </div>
                    {viewPermission && viewPermission?.has("view") &&
                        <div color="secondary" className="btn-icon cursor-img" onClick={toggleSettingsModal}>
                            <i className="ri-settings-2-line fs-4"></i>
                        </div>}
                </div>
            </div>
            <div className="py-4">
                <Row>
                    {userRolesSummaryCards.map((item, idx) => (
                        <Col key={idx} lg={4} md={6} xs={12} className="my-2">
                            <div className="border border-1 p-2 d-flex justify-content-between align-items-center">
                                <div className="d-flex flex-column">
                                    <span className="fw-bold fs-16">{item.label}</span>
                                    <span className="fw-semibold fs-1">{item.value}</span>
                                </div>
                                <div>
                                    <i className={`${item.icon} fs-1`} style={{ color: item.color }}></i>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>

            </div>


        </div>


        // <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between w-100">
        //     <div className="d-flex flex-column flex-md-row">
        //         <Button color="primary" className="btn-label me-2" onClick={() => { handleExportDataForUser(Policies) }}>
        //             <i className="ri-download-line label-icon align-middle fs-16 me-2 " ></i> Export Data
        //         </Button>
        //         {userPermission && userPermission?.permissionList?.includes('create') ? <Button color="primary" className="btn-label me-2 mb-2 mb-md-0" onClick={() => navigateToAddUser(navigate)}>
        //             <i className="ri-add-fill label-icon align-middle fs-16 me-2"></i> Add User
        //         </Button> : null}
        //     </div>
        //     <div className="d-flex align-items-center">
        //         <div color="secondary" className="btn-icon me-2 cursor-img" onClick={toggleSettingsModal}>
        //             <i className="ri-settings-2-line fs-4"></i>
        //         </div>
        //     </div>
        // </div>
    )
}